<div class="frame-8-2"  [style.background]="backgroundColor">
    <p class="text-1">{{message}}</p>
</div>